import React, { useEffect } from "react";
import "../assets/css/north.css";
import "../assets/css/home.css";
import "aos/dist/aos.css";
import AOS from "aos";
import hero1 from "../assets/TIG Website Images/Our Businesses/IT/ITDepartment.png";
import aboutImg from "../assets/it-solution.jpg"; 
import {
  ShieldCheck,
  Lock,
  Brain,
  BarChart3,
  CloudCog,
  Layers
} from "lucide-react";
import '../assets/css/home.css'
const ItSolution = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid p-0">
        <div
          className="hero-section"
          style={{ backgroundImage: `url(${hero1})` }}
        >
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div className="col-lg-10 zoom-in-text">
              <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
              Towers International – IT Solutions
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <section className="py-5 ">
        <div className="container">
          <div className="row align-items-center ">
            {/* Text Content */}
            <div className="col-lg-6 px-3 px-md-0" data-aos="fade-up">
              <h1 className="fw-bold mb-4 ">Towers International  –  IT Solutions </h1>
              <p className="mb-3 fs-5">
                Over the past decade, Towers International has evolved from a
                dynamic SME into a trusted IT solutions provider with multi-million
                annual turnover, driven by innovation, strategic partnerships, and
                deep expertise in specialized areas of technology and business services.
              </p>
              <p className="mb-3 fs-5">
                We have developed a strong network of strategic partnerships with
                leading global technology providers and specialized experts, allowing
                us to deliver comprehensive, high-impact solutions across key sectors
                such as finance, energy, infrastructure, and government.
              </p>
            </div>

            {/* Image */}
            <div className="col-lg-6 text-center" data-aos="fade-up">
              <img
                src={aboutImg}
                alt="About Towers International"
                className="img-fluid rounded shadow-lg"
                style={{width:"600px" ,height:"500px",objectFit:"cover"}}
              />
            </div>
          </div>
        </div>
      </section>
      
{/* Key IT Services Section */}
<section className="py-5">
  <div className="container">
    {/* Section Heading */}
    <div className="text-center mb-5" data-aos="fade-up">
      <h2 className="fw-bold display-6">Our Key IT Services</h2>
      <p className="text-muted fs-5">
        Empowering businesses with innovative, secure, and reliable IT solutions
      </p>
    </div>

    {/* Services Grid */}
    <div className="row g-4">
      {/* Service 1 */}
      <div className="col-md-6 col-lg-4" data-aos="zoom-in">
        <div className="card h-100 shadow-lg border-0 rounded-4 p-4 text-center service-card-it-it">
          <ShieldCheck size={42} className="text-primary mb-3" />
          <h5 className="fw-bold mb-3">Governance, Risk & Compliance (GRC)</h5>
          <p className="text-muted fs-6">
            Comprehensive frameworks for regulatory compliance, risk assessment,
            and corporate governance aligned with international standards.
          </p>
        </div>
      </div>

      {/* Service 2 */}
      <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-delay="100">
        <div className="card h-100 shadow-lg border-0 rounded-4 p-4 text-center service-card-it">
          <Lock size={42} className="text-danger mb-3" />
          <h5 className="fw-bold mb-3">IT Security & Penetration Testing</h5>
          <p className="text-muted fs-6">
            Proactive vulnerability assessments, ethical hacking, and security
            audits to safeguard critical business systems and data.
          </p>
        </div>
      </div>

      {/* Service 3 */}
      <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-delay="200">
        <div className="card h-100 shadow-lg border-0 rounded-4 p-4 text-center service-card-it">
          <Brain size={42} className="text-success mb-3" />
          <h5 className="fw-bold mb-3">AI & Data Consultancy</h5>
          <p className="text-muted fs-6">
            Artificial Intelligence integration, data strategy, predictive
            analytics, and business intelligence solutions to drive smarter
            decision-making.
          </p>
        </div>
      </div>

      {/* Service 4 */}
      <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-delay="300">
        <div className="card h-100 shadow-lg border-0 rounded-4 p-4 text-center service-card-it">
          <BarChart3 size={42} className="text-warning mb-3" />
          <h5 className="fw-bold mb-3">Financial Modelling & Business Analytics</h5>
          <p className="text-muted fs-6">
            Advanced financial forecasting, scenario planning, and investment
            analysis tailored for SMEs and large-scale projects.
          </p>
        </div>
      </div>

      {/* Service 5 */}
      <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-delay="400">
        <div className="card h-100 shadow-lg border-0 rounded-4 p-4 text-center service-card-it">
          <CloudCog size={42} className="text-info mb-3" />
          <h5 className="fw-bold mb-3">Digital Transformation & Managed IT Services</h5>
          <p className="text-muted fs-6">
            End-to-end IT infrastructure, cloud solutions, network security, and
            24/7 support for seamless business operations.
          </p>
        </div>
      </div>

      {/* Service 6 */}
      <div className="col-md-6 col-lg-4" data-aos="zoom-in" data-aos-delay="500">
        <div className="card h-100 shadow-lg border-0 rounded-4 p-4 text-center service-card-it">
          <Layers size={42} className="text-secondary mb-3" />
          <h5 className="fw-bold mb-3">Custom Software & ERP Development</h5>
          <p className="text-muted fs-6">
            Tailored applications, process automation, and integration of ERP/CRM
            platforms to optimize efficiency.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

{/* new */}
 {/* <section className="subsidiary-grid py-5">
      <div className="container text-center" data-aos="fade-up">
        <h2 className="grid-title fw-bold mb-4">Our Subsidiaries</h2>
        <p className="grid-subtitle fs-5 mb-5">
          Businesses working together to create lasting impact
        </p>

        <div className="row g-4 justify-content-center">
          {[
            "Towers Investment",
            "Modern Buildings Construction LLC.",
            "Towers Training",
            "Golden Space Tech.",
            "New Elite International LLC.",
            "Northstar Financial Consultancy",
          ].map((subsidiary, index) => (
            <div
              className="col-md-4 col-sm-6"
              key={index}
              data-aos="zoom-in" 
              data-aos-delay={index * 100}
            >
              <div className="subsidiary-block">
                <span className="subsidiary-index">{index + 1}</span>
                <h5 className="subsidiary-name">{subsidiary}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section> */}

    </div>
  );
};

export default ItSolution;
